<script lang="ts">
  import cssVars from "svelte-css-vars";

  import { browser } from "$app/environment";

  import { isWebView } from "../env";
  import { localeIsLoading } from "../i18n";
  import { proxyHost } from "../store/proxyHost";
  import Bg from "./Bg.svelte";
  import { themeConfig } from "./themeConfig";

  const urlParams = new URLSearchParams(window.location.search);
  $: theme = $themeConfig?.theme || urlParams.get("theme");
  const { style } = document.body;
  const setBg = (theme: string | null) => {
    const color = theme === "light" ? "hsla(264, 24%, 98%, 1)" : "hsla(258, 24%, 8%, 1)";

    if (!isWebView) {
      style.setProperty("--body-bg-color", color);
    }
  };
  $: setBg(theme);
</script>

<style lang="postcss">
  :global(body) {
    background-color: var(--body-bg-color);
  }
</style>

<div
  class="contents"
  style="color: hsl(var(--color-primary-text, var(--color-N100)));"
  use:cssVars={$themeConfig?.palette ? $themeConfig?.palette : $themeConfig || {}}>
  <div
    class="fixed inset-0 -z-10 bg-cover bg-fixed"
    style={isWebView
      ? "background: linear-gradient(0deg, hsl(var(--color-N04)/ 0.87), transparent)"
      : ""}>
    {#if browser && !isWebView}
      <Bg {theme} />
    {/if}
  </div>
  {#if $proxyHost && !$localeIsLoading}
    <slot />
  {/if}
</div>
